<script>
	export default {
		name: 'ComponentExecuter',
		methods: {
			getComponentContents(key) {
				const self_ = this;
				const contents_ = self_.getContentsState('component')
				if(self_.isFalse(contents_)) { return {} }
				return contents_[key]
			},
			getComponentInits(key) {
				const self_ = this;
				const inits_ = self_.getInitsState('component')
				if(self_.isFalse(inits_)) { return {} }
				return inits_[key]
			},
			setComponentContents(key, value) {
				const self_ = this;
				self_.setContentsState('component', key, value)
			},
			setComponentInits(key, value) {
				const self_ = this;
				self_.setInitsState('component', key, value)
			},
			initializeComponent(componentName) {
				const self_ = this;

				const dataTypes_ = ['contents', 'inits']

				let promiseArray_ = []

				dataTypes_.forEach(dataType => {
					promiseArray_.push(self_.$_cpExec_setComponentData(componentName, dataType))
				})

				return Promise.all(promiseArray_)
			},
			$_cpExec_setComponentData(componentName, dataType) {
				const self_ = this;

				const default_ = self_.$_cpExec_getDefault(componentName, dataType)

				let result_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.getFirestoreSubCollection(dataType, 'component', componentName)
					}).then(result => {
						if(self_.isEmpty(result)) {
							result_ = default_
						} else {
							result_ = self_.$_cpExec_mergeDefault(default_, result)
						}

						self_.$_cpExec_setComponentState(dataType, componentName, result_)

						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: setComponentData(' + componentName + ', ' + dataType + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_cpExec_getDefault(componentName, dataType) {
				const self_ = this;
				
				let type_ = null;

				if(self_.isFalse(componentName)) { type_ = 'default_' }
				else { type_ = componentName + '_' }

				const nameState_ = self_.$_cpExec_getComponentState(dataType, componentName)
				const typeState_ = self_.$_cpExec_getComponentState(dataType, type_)
				const defaultState_ = self_.$_cpExec_getComponentState(dataType, 'default_')

				if(self_.isObject(nameState_)) { return nameState_; }
				else if(self_.isObject(typeState_)) { return typeState_; }
				else { return defaultState_ }
			},
			$_cpExec_mergeDefault(defaultObj, resultObj) {
				Object.keys(resultObj).forEach(key => {
					if(defaultObj[key]) {
						Object.keys(resultObj[key]).forEach(subKey => {
							defaultObj[key][subKey] = resultObj[key][subKey]
						})
					} else {
						defaultObj[key] = resultObj[key]
					}
				})

				return defaultObj
			},
			$_cpExec_getComponentState(dataType, key) {
				const self_ = this;
				
				if(dataType == 'contents') { return self_.getComponentContents(key) }
				if(dataType == 'inits') { return self_.getComponentInits(key) }
			},
			$_cpExec_setComponentState(dataType, key, value) {
				const self_ = this;
				
				if(dataType == 'contents') { self_.setComponentContents(key, value) }
				if(dataType == 'inits') { self_.setComponentInits(key, value) }
			}
		}
	}
</script>